<template>
  <div class="bg-292a2e p-relative">
    <div class="flex align-center justify-space-between h-170 container">
      <div class="flex-1">
        <div class="font-30 font-yahei color-94 mb-20">联系我们</div>
        <div class="font-12 color-94 flex align-center mb-8"><img src="/images/telxia.png" alt="" class="mr-10"><span>服务热线：</span><span class="color-838c96 font-16 font-arial">4007-123-123</span></div>
        <div class="font-12 color-94 flex align-center"><img src="/images/dizhi.png" alt="" class="mr-10"><span>公司地址：云南省昆明市西山区中天融域二期写字楼24栋1单元8楼</span></div>
      </div>
      <div class="flex-1 flex justify-center"><img src="/images/logoxia.png" alt=""></div>
      <div class="flex-column justify-center align-end flex-1">
        <div class="flex-column justify-center align-center">
        <el-image
          style="width: 90px; height: 90px"
          src="https://dss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=272593219,596345318&fm=111&gp=0.jpg"
          fit="cover"></el-image>
        <div class="font-12 color-94 mt-10">微信扫码关注鲁班兄弟</div>
        </div>
      </div>
    </div>
    <div class="footer-hr"></div>
    <div class="footer flex justify-center align-center">
      <div class="color-94 font-12">© 鲁班兄弟 版权所有  ICP备案：滇ICP备20200000号-0</div>
    </div>
    <img src="/images/footer-top.png" alt="" class="top">
  </div>
</template>

<script>

export default {
  name: "Index",
  components: {},
  data () {
    return {
    }
  },
  created () {},
  mounted () {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.h-170{
  height: 170px;
}
  .footer {
    height: 30px;
  }
  .footer-hr{
    height: 1px;
    background: #343539;
  }
  .top{
    position: absolute;
    top: -15px;
    left: calc(50% - 75px);
  }
</style>
